module.exports = __webpack_public_path__ + "img/gfzd.48fd5357.png";